export default function SkeletonCard() {
  return (
    <div style={{
      background: 'rgba(255,255,255,0.03)',
      border: '0.5px solid rgba(212,83,126,0.1)',
      borderRadius: 16, marginBottom: 20, overflow: 'hidden',
    }}>
      <style>{`
        @keyframes shimmer {
          0% { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }
        .shimmer {
          background: linear-gradient(90deg, rgba(255,255,255,0.03) 0%, rgba(212,83,126,0.08) 50%, rgba(255,255,255,0.03) 100%);
          background-size: 600px 100%;
          animation: shimmer 1.6s infinite linear;
        }
      `}</style>

      {/* Top bar */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <div className="shimmer" style={{ width: 32, height: 32, borderRadius: '50%' }} />
          <div>
            <div className="shimmer" style={{ width: 80, height: 11, borderRadius: 6, marginBottom: 5 }} />
            <div className="shimmer" style={{ width: 50, height: 9, borderRadius: 6 }} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          <div className="shimmer" style={{ width: 55, height: 26, borderRadius: 20 }} />
          <div className="shimmer" style={{ width: 50, height: 26, borderRadius: 20 }} />
        </div>
      </div>

      {/* Album art */}
      <div className="shimmer" style={{ width: '100%', height: 200 }} />

      {/* Song info */}
      <div style={{ padding: '14px 16px 0' }}>
        <div className="shimmer" style={{ width: '70%', height: 18, borderRadius: 6, marginBottom: 8 }} />
        <div className="shimmer" style={{ width: '40%', height: 12, borderRadius: 6 }} />
      </div>

      {/* Reactions row */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px' }}>
        <div style={{ display: 'flex', gap: 6 }}>
          {[...Array(6)].map((_, i) => (
            <div key={i} className="shimmer" style={{ width: 32, height: 32, borderRadius: 10 }} />
          ))}
        </div>
        <div className="shimmer" style={{ width: 90, height: 32, borderRadius: 20 }} />
      </div>
    </div>
  );
}